<template>
  <div class="container mt-4">
    <button @click="goBack" class="btn btn-secondary mb-3">
      <font-awesome-icon icon="arrow-left" /> Zurück zur Übersicht
    </button>
    <h2 class="mb-3">Rabatt anwenden</h2>
    <form @submit.prevent="applyDiscounts" class="form-group">
      <div class="mb-3">
        <label for="days" class="form-label">Älter als (Tage):</label>
        <input type="number" id="days" v-model="days" class="form-control" required />
      </div>

      <div class="mb-3">
        <label for="discountPercent" class="form-label">Rabatt in Prozent:</label>
        <input type="number" id="discountPercent" v-model="discountPercent" class="form-control" required />
      </div>

      <button type="submit" class="btn btn-primary">Rabatt anwenden</button>
    </form>
  </div>
</template>

<script>
import axios from '@/services/axios';

export default {
  data() {
    return {
      days: 30, // Beispielwert, kann dynamisch angepasst werden
      discountPercent: 20, // Beispielwert, kann dynamisch angepasst werden
    };
  },
  methods: {
    async applyDiscounts() {
      try {
        const response = await axios.post('/articles/apply-discounts', {
          days: this.days,
          discountPercent: this.discountPercent,
        });

        console.log(response.data.message);
      } catch (error) {
        console.error('Fehler beim Anwenden der Rabatte:', error);
      }
    },
    goBack() {
      if (this.$route.path.includes('customers')) {
        this.$router.push('/customers');
      } else if (this.$route.path.includes('items')) {
        this.$router.push('/items');
      }
    }
  },
};
</script>


<style scoped>
.container {
  max-width: 600px;
}
</style>